import React, {useEffect, useState} from 'react'
import Modal from '../Modal'
import NewModal from '../NewModal/NewModal'
import Form from '../Form/Form'
import FormInput from '../Inputs/FormInput/FormInput'
import {useForm} from 'react-hook-form'
import ApiSearchInput from './APISearchInput'
import {observer} from 'mobx-react'
import ModalsStore from '../Pages/Modals.store'
import AttentionGenerator from '../Form/AttentionGenerator'
import styled from "styled-components";
import CheckboxInput from "../Inputs/CheckboxInput/CheckboxInput";
import RadioInput from "../Inputs/RadioInput/RadioInput";



const QuizMammoModal = observer(() => {
    const NAME = `QuizMammoModal`
    const {data, methods} = ModalsStore.Modals[NAME]
    const [status, setStatus] = useState()
    const [error, setError] = useState({})
    const [afterUltrasound, setAfterUltrasound] = useState(data.initialForm.afterUltrasound)
    const [afterMammography, setAfterMammography] = useState(data.initialForm.afterMammography)
    const [regularity, setRegularity] = useState(data.initialForm.regularity)	
    const [registered, setRegistered] = useState(data.initialForm.registered)
    const [registeredAdenomatoz, setRegisteredAdenomatoz] = useState(data.initialForm.registeredAdenomatoz)
    const [registeredAdenoma, setRegisteredAdenoma] = useState(data.initialForm.registeredAdenoma)
    const [registeredCist, setRegisteredCist] = useState(data.initialForm.registeredCist)
    const [registeredTumor, setRegisteredTumor] = useState(data.initialForm.registeredTumor)
    const [registeredMastit, setRegisteredMastit] = useState(data.initialForm.registeredMastit)
    const [operations, setOperations] = useState(data.initialForm.operations)
    const [operationsRight, setOperationsRight] = useState(data.initialForm.operationsRight)
    const [operationsRightYear, setOperationsRightYear] = useState(data.initialForm.operationsRightYear)
    const [operationsRightDiagnisis, setOperationsRightDiagnisis] = useState(data.initialForm.operationsRightDiagnisis)
    const [operationsLeft, setOperationsLeft] = useState(data.initialForm.operationsLeft)
    const [operationsLeftYear, setOperationsLeftYear] = useState(data.initialForm.operationsLeftYear)
    const [operationsLeftDiagnisis, setOperationsLeftDiagnisis] = useState(data.initialForm.operationsLeftDiagnisis)
    const [periodsNow, setPeriodsNow] = useState(data.initialForm.periodsNow)
    const [complaints, setСomplaints] = useState(data.initialForm.complaints)
    const [complaintsRight, setСomplaintsRight] = useState(data.initialForm.complaintsRight)
    const [complaintsLeft,  setСomplaintsLeft] = useState(data.initialForm.complaintsLeft)
    const [complaintsCharacterPain, setComplaintsCharacterPain] = useState(data.initialForm.complaintsCharacterPain)
    const [complaintsCharacterDiscomfort, setComplaintsCharacterDiscomfort] = useState(data.initialForm.complaintsCharacterDiscomfort)
    const [complaintsCharacterDischarge, setComplaintsCharacterDischarge] = useState(data.initialForm.complaintsCharacterDischarge)
    const [complaintsCharacterSeals, setComplaintsCharacterSeals] = useState(data.initialForm.complaintsCharacterSeals)
    const [complaintsCharacterPeriod, setComplaintsCharacterPeriod] = useState(data.initialForm.complaintsCharacterPeriod)
    const [complaintsCharacterUnperiod, setComplaintsCharacterUnperiod] = useState(data.initialForm.complaintsCharacterUnperiod)
    const [review, setReview] = useState(data.initialForm.review)
    const [rdoza, setRdoza] = useState(data.initialForm.rdoza)
	

    const {errors, setValue, watch, register, handleSubmit} = useForm(
        {defaultValues: data.initialForm})


    return (
        <Modal mobile={true}>
            <NewModal
                completed={status}
                completedText={'Сохранено!'}
                completedButtonText={'Продолжить'}
                title={'Анкета маммография'}
                closeHandler={_ => ModalsStore.closeModal(NAME)}
				style={{width: '90%', height:'90%',maxHeight:'100%'}}
				hideErrors={true}
				containerStyle={{width: '90%', height:'100%',maxHeight:'100%'}}
            >

                <Form submitHandler={handleSubmit(async (formData) => {
                    await methods.submit({...formData, 
							regularity, 
							afterUltrasound,afterMammography,
							registered, registeredAdenomatoz, registeredAdenoma, registeredCist, registeredTumor, registeredMastit,
							operations, operationsRight, operationsLeft,
							periodsNow, complaints, complaintsRight, complaintsLeft,
							complaintsCharacterPain, complaintsCharacterDiscomfort, complaintsCharacterSeals,
							complaintsCharacterPeriod, complaintsCharacterUnperiod, complaintsCharacterDischarge,
							review,rdoza,
						}) // 
                        .then(response => response !== 'success'
                            ? setError({
                                type: 'def',
                                message: 'Ой. У нас что-то пошло не так. Повторите свою попытку позже.'
                            })
                            : setStatus(true))

                })} submitButtonText={'Сохранить'}>
					<div style={{flex:1,flexDirection:'row',display: 'flex',}}>
						<div style={{flex:1, paddingRight: 10,}}>
							<p style={{marginTop: '15px'}}>Исследование м/ж проводится </p>
							<RadioInput title={'Впервые'} name={'regularity'} value={'first'}
								checked={regularity=='first'} onChange={_ => {setRegularity('first')}} />
							<RadioInput title={'Повторно'} name={'regularity'} value={'re'}
								checked={regularity=='re'} onChange={_ => {setRegularity('re')}} />

							<p style={{marginTop: '15px'}}>Ранее выполнялось</p>
							<CheckboxInput title="Узи"
							   checked={afterUltrasound} onClick={_ => {setAfterUltrasound(!afterUltrasound)}} />
							<CheckboxInput title="Маммография"
							   checked={afterMammography} onClick={_ => {setAfterMammography(!afterMammography)}} />

							<p style={{marginTop: '15px'}}>Состоите на учете по заболеванию м/ж </p>
							<RadioInput title={'Нет'} name={'registered'} value={'no'}
								checked={registered=='no'} onChange={_ => {setRegistered('no')}} />
							<RadioInput title={'Да'} name={'registered'} value={'yes'}
								checked={registered=='yes'} onChange={_ => {setRegistered('yes')}} />
							{registered=='yes' ? <>
								<CheckboxInput title="Фиброаденоматоз"
								   checked={registeredAdenomatoz} onClick={_ => {setRegisteredAdenomatoz(!registeredAdenomatoz)}} />
								<CheckboxInput title="Фиброаденома"
								   checked={registeredAdenoma} onClick={_ => {setRegisteredAdenoma(!registeredAdenoma)}} />
								<CheckboxInput title="Киста"
								   checked={registeredCist} onClick={_ => {setRegisteredCist(!registeredCist)}} />
								<CheckboxInput title="Опухоль"
								   checked={registeredTumor} onClick={_ => {setRegisteredTumor(!registeredTumor)}} />
								<CheckboxInput title="Мастит"
								   checked={registeredMastit} onClick={_ => {setRegisteredMastit(!registeredMastit)}} />
							</> : undefined}
						</div>

						<div style={{flex:1, paddingRight: 30,}}>
							<p style={{marginTop: '15px'}}>Были ли операции на м/ж </p>
							<RadioInput title={'Нет'} name={'operations'} value={'no'}
								checked={operations=='no'} onChange={_ => {setOperations('no')}} />
							<RadioInput title={'Да'} name={'operations'} value={'yes'}
								checked={operations=='yes'} onChange={_ => {setOperations('yes')}} />
							{operations=='yes' ? <>
								<CheckboxInput title="На правой" 
								   checked={operationsRight} onClick={_ => {setOperationsRight(!operationsRight)}} />
								{operationsRight ? <div style={{border:'solid',borderColor:'#aaa',borderWidth:1,borderRadius:7,
									padding:7,marginTop:0,marginBottom:15,}}>
									<FormInput hideIcon reff={register({})}
										name='operationsRightYear'
										title={'в каком году'}/>
									<FormInput hideIcon reff={register({})}
										name='operationsRightDiagnisis'
										title={'Диагноз'}/>
								</div> : undefined}
								<CheckboxInput title="На левой"
								   checked={operationsLeft} onClick={_ => {setOperationsLeft(!operationsLeft)}} />
								{operationsLeft ? <div style={{border:'solid',borderColor:'#aaa',borderWidth:1,borderRadius:7,
									padding:7,marginTop:0,marginBottom:15,}}>
									<FormInput hideIcon reff={register({})}
										name='operationsLeftYear'
										title={'в каком году'}/>
									<FormInput hideIcon reff={register({})}
										name='operationsLeftDiagnisis'
										title={'Диагноз'}/>
								</div> : undefined}
							</> : undefined}
			
						</div>

						<div style={{flex:1, paddingRight: 10,}}>
							<p style={{marginTop: '15px'}}>Есть ли жалобы со стороны молочных желез</p>
							<RadioInput title={'Нет'} name={'complaints'} value={'no'}
								checked={complaints=='no'} onChange={_ => {setСomplaints('no')}} />
							<RadioInput title={'Да'} name={'complaints'} value={'yes'}
								checked={complaints=='yes'} onChange={_ => {setСomplaints('yes')}} />
							{complaints=='yes' ? <>
								<CheckboxInput title="На правой"
								   checked={complaintsRight} onClick={_ => {setСomplaintsRight(!complaintsRight)}} />
								<CheckboxInput title="На левой"
								   checked={complaintsLeft} onClick={_ => {setСomplaintsLeft(!complaintsLeft)}} />

								<p style={{marginTop: '15px'}}>Характер жалоб </p>
								<CheckboxInput title="Боль"
								   checked={complaintsCharacterPain} onClick={_ => {setComplaintsCharacterPain(!complaintsCharacterPain)}} />
								<CheckboxInput title="Неприятные ощущения"
								   checked={complaintsCharacterDiscomfort} onClick={_ => {setComplaintsCharacterDiscomfort(!complaintsCharacterDiscomfort)}} />
								<CheckboxInput title="Выделения из соска"
								   checked={complaintsCharacterDischarge} onClick={_ => {setComplaintsCharacterDischarge(!complaintsCharacterDischarge)}} />
								<CheckboxInput title="Прощупывается уплотнения"
								   checked={complaintsCharacterSeals} onClick={_ => {setComplaintsCharacterSeals(!complaintsCharacterSeals)}} />
								<CheckboxInput title="Боль связана с месячными"
								   checked={complaintsCharacterPeriod} onClick={_ => {setComplaintsCharacterPeriod(!complaintsCharacterPeriod)}} />
								<CheckboxInput title="Боль не связана с месячными"
								   checked={complaintsCharacterUnperiod} onClick={_ => {setComplaintsCharacterUnperiod(!complaintsCharacterUnperiod)}} />
							</> : undefined}
						</div>

						<div style={{flex:1}}>

							<p style={{marginTop: '15px'}}>В настоящее время</p>
							<RadioInput title={'Менструация есть'} name={'periodsNow'} value={'yes'}
								checked={periodsNow=='yes'} onChange={_ => {setPeriodsNow('yes')}} />
							<RadioInput title={'Менструаций нет'} name={'periodsNow'} value={'no'}
								checked={periodsNow=='no'} onChange={_ => {setPeriodsNow('no')}} />
							<RadioInput title={'Нарушение цикла'} name={'periodsNow'} value={'broke'}
								checked={periodsNow=='broke'} onChange={_ => {setPeriodsNow('broke')}} />
							<RadioInput title={'Климакс'} name={'periodsNow'} value={'climax'}
								checked={periodsNow=='climax'} onChange={_ => {setPeriodsNow('climax')}} />
							<RadioInput title={'Менопауза'} name={'periodsNow'} value={'menopause'}
								checked={periodsNow=='menopause'} onChange={_ => {setPeriodsNow('menopause')}} />
							<br/>
							<FormInput hideIcon reff={register({})}
								name='lastPeriods'
								title={'Если есть месячные, указать первый день последних месячных в текущем году'}/>

							<p style={{marginTop: '15px'}}>Внешний осмотр</p>
							<textarea value={review} onChange={(event) => {setReview(event.target.value)}} 
								style={{width:'100%',height:'120px'}}/>
							<p style={{marginTop: '15px'}}>Доза ЭЭД, млЗв</p>		
							<input value={rdoza} onChange={(event) => {setRdoza(event.target.value)}} 
								style={{width:'100%'}}/>						
						</div>

					</div>
                </Form>
            </NewModal>
        </Modal>
    )
})
const StyledAttention = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 12px;
`

export default QuizMammoModal
